// @flow
import React from "react";
import { connect } from "react-redux";

import { LinkButton } from "@quantum/ui";
import { Translate } from "@quantum/i18n";

import type { FiltroTipoAtivo } from "../../model";
import type { ActionCreator } from "../../state";
import {
  getFiltrosTipoAtivoPermitidos,
  getFiltrosTipoAtivoSelecionados,
  selecionarFiltrosTipoAtivo,
  deselecionarFiltrosTipoAtivo,
} from "../../state";

import "./selecao-filtro-tipo-ativo.css";

type Props = {
  filtrosTipoAtivo: Array<FiltroTipoAtivo>,
  filtrosTipoAtivoSelecionados: Array<FiltroTipoAtivo>,
  selecionarFiltrosTipoAtivo: ActionCreator,
  deselecionarFiltrosTipoAtivo: ActionCreator,
};

function SelecaoFiltroTipoAtivo({
  filtrosTipoAtivo,
  filtrosTipoAtivoSelecionados,
  selecionarFiltrosTipoAtivo,
  deselecionarFiltrosTipoAtivo,
}: Props) {
  function handleFiltroChange(event: SyntheticInputEvent<>) {
    event.target.checked
      ? selecionarFiltrosTipoAtivo([parseInt(event.target.value)])
      : deselecionarFiltrosTipoAtivo([parseInt(event.target.value)]);
  }

  function handleMarcarDesmarcar(event) {
    filtrosTipoAtivoSelecionados.length === filtrosTipoAtivo.length
      ? deselecionarFiltrosTipoAtivo(filtrosTipoAtivo.map(filtro => filtro.id))
      : selecionarFiltrosTipoAtivo(filtrosTipoAtivo.map(filtro => filtro.id));
  }

  if (!filtrosTipoAtivo.length) {
    return null;
  }

  return (
    <div className="SelecaoFiltroTipoAtivo">
      <div className="SelecaoFiltroTipoAtivo__filtros">
        {filtrosTipoAtivo.map(filtro => (
          <div
            className="SelecaoFiltroTipoAtivo__filtro"
            key={"check" + filtro.id}
          >
            <input
              id={filtro.id}
              type={"checkbox"}
              value={filtro.id}
              onChange={handleFiltroChange}
              checked={filtrosTipoAtivoSelecionados.includes(filtro.id)}
            />
            <label
              className="SelecaoFiltroTipoAtivo__texto-filtro"
              htmlFor={filtro.id}
            >
              <Translate>{filtro.chaveTraducao}</Translate>
            </label>
          </div>
        ))}
      </div>
      <LinkButton
        className="SelecaoFiltroTipoAtivo__marcar-desmarcar"
        type="button"
        onClick={handleMarcarDesmarcar}
      >
        {filtrosTipoAtivoSelecionados.length === filtrosTipoAtivo.length ? (
          <Translate>Comum.desmarcarTodos</Translate>
        ) : (
          <Translate>Comum.marcarTodos</Translate>
        )}
      </LinkButton>
    </div>
  );
}

export default connect(
  state => ({
    filtrosTipoAtivo: getFiltrosTipoAtivoPermitidos(state),
    filtrosTipoAtivoSelecionados: getFiltrosTipoAtivoSelecionados(state),
  }),
  {
    selecionarFiltrosTipoAtivo,
    deselecionarFiltrosTipoAtivo,
  }
)(SelecaoFiltroTipoAtivo);
